export default __webpack_public_path__ + "static/media/calendarGray.d9cb8fae.svg";